import { SalesTaxFilingFrequencyEnum } from '@commenda/prisma';
import { FilingReviewStatus } from '../../../ui/molecules/filings/types';

export interface FilingCalendarPreviewRequest {
  corporation_id: number;
  state: string;
  filing_frequency: SalesTaxFilingFrequencyEnum;
  tax_period_start_month: string; // YYYY-MM-DD
  tax_period_end_month?: string; // YYYY-MM-DD (optional)
}

export interface FilingCalendarGenerateRequest {
  corporation_id: number;
  state: string;
  filing_frequency: SalesTaxFilingFrequencyEnum;
  tax_period_start_month: string; // YYYY-MM-DD
  tax_period_end_month?: string; // YYYY-MM-DD (optional)
}

export interface DeleteFilingsByStateRequest {
  corporation_id: number;
  state: string;
}

export enum FilingCalendarPreviewErrorSubType {
  INVALID_STATE_CODES = 'SUB_FILINGS_INVALID_STATE_CODES_IN_PARAMS',
  INVALID_FILING_FREQUENCY = 'SUB_FILINGS_INVALID_FILING_FREQUENCY_IN_PARAMS',
  INVALID_MONTH_FORMAT = 'SUB_FILINGS_INVALID_MONTH_FORMAT',
  FREQUENCY_NOT_AVAILABLE_FOR_STATE = 'SUB_FILINGS_FREQUENCY_NOT_AVAILABLE_FOR_STATE',
  INVALID_DATE_RANGE = 'SUB_FILINGS_INVALID_DATE_RANGE',
  NO_FILINGS_FOUND = 'SUB_FILINGS_NO_FILINGS_FOUND',
  FILED_CONFLICT = 'SUB_FILINGS_FILED_CONFLICT',
  COVERAGE_GAPS_DETECTED = 'SUB_FILINGS_COVERAGE_GAPS_DETECTED',
}

export interface FilingPreviewEntry {
  id?: string;
  form_title: string;
  state: string;
  filing_frequency: SalesTaxFilingFrequencyEnum;
  tax_period_start_date: string;
  tax_period_end_date: string;
  reporting_period_start_date: string;
  reporting_period_end_date: string;
  due_date: string;
  status?: FilingReviewStatus;
  description?: string;
}

export interface CoverageGapEntry {
  tax_period_start_date: string;
  tax_period_end_date: string;
  previously_covered_by: string;
  reason: string;
}

export interface FilingCalendarPreviewData {
  existing_filings: FilingPreviewEntry[];
  proposed_filings: FilingPreviewEntry[];
  filings_to_delete: FilingPreviewEntry[];
  final_calendar: FilingPreviewEntry[];
  has_filed_conflict: boolean;
  conflicting_filings?: FilingPreviewEntry[];
  has_coverage_gaps: boolean;
  coverage_gaps?: CoverageGapEntry[];
  validation_errors?: FilingCalendarPreviewErrorSubType[];
  can_generate: boolean;
}

export interface FilingCalendarPreviewResponse {
  data: FilingCalendarPreviewData;
  message: string;
}

export interface FilingCalendarGenerateData {
  created_filings: FilingPreviewEntry[];
  deleted_filings: FilingPreviewEntry[];
  total_created: number;
  total_deleted: number;
}

export interface FilingCalendarGenerateResponse {
  data: FilingCalendarGenerateData;
  message: string;
}

export interface DeleteFilingsByStateData {
  deleted_count: number;
}

export interface DeleteFilingsByStateResponse {
  data: DeleteFilingsByStateData;
  message: string;
}
